import { ACTIVE, COMPLETED, CONFIRMED } from './Status';

export const AllowCreateVisitStatus = [ACTIVE, COMPLETED, CONFIRMED];

export const AllowCancelStatus = [ACTIVE, CONFIRMED];
